<rt-trip [tripId]="ormId" (dirty)="onDirty()"></rt-trip>
